import React, { useEffect, useState } from "react";
import { jumpToSetupSection, followSetupHash } from "../../../utility/setupJump";

const tabClass = (isActive) =>
  `flex items-center gap-2 min-h-11 py-2 px-3 sm:px-4 border-b-2 font-display font-bold text-sm tracking-wide whitespace-nowrap transition-colors duration-200 ${
    isActive
      ? "border-brand-charcoal text-brand-charcoal"
      : "border-transparent text-brand-muted hover:text-brand-charcoal"
  }`;

const SetupJumpBar = ({ sections }) => {
  const [activeId, setActiveId] = useState(sections[0]?.id || "");

  useEffect(() => {
    const nodes = sections
      .map((section) => document.getElementById(section.id))
      .filter(Boolean);
    if (nodes.length === 0) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort(
            (left, right) => right.intersectionRatio - left.intersectionRatio
          );
        if (visible[0]?.target?.id) {
          setActiveId(visible[0].target.id);
        }
      },
      {
        rootMargin: "-80px 0px -55% 0px",
        threshold: [0.1, 0.25, 0.5],
      }
    );

    nodes.forEach((node) => observer.observe(node));
    return () => observer.disconnect();
  }, [sections]);

  useEffect(() => {
    const id = window.location.hash.replace(/^#/, "");
    if (!id || !sections.some((section) => section.id === id)) return undefined;
    setActiveId(id);
    return followSetupHash(id);
  }, [sections]);

  const jumpTo = (id) => {
    if (!jumpToSetupSection(id)) return;
    setActiveId(id);
    window.history.replaceState(null, "", `#${id}`);
  };

  const goToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (sections.length === 0) return null;

  return (
    <nav
      className="flex flex-wrap items-stretch px-2 sm:px-4"
      aria-label="Setup sections"
    >
      {sections.map((section) => {
        const isActive = section.id === activeId;
        return (
          <button
            key={section.id}
            type="button"
            onClick={() => jumpTo(section.id)}
            aria-current={isActive ? "true" : undefined}
            className={tabClass(isActive)}
          >
            {section.label}
          </button>
        );
      })}
      <button
        type="button"
        onClick={goToTop}
        className="min-h-11 ml-auto px-3 sm:px-4 border-b-2 border-transparent font-display font-bold text-sm tracking-wide text-brand-muted hover:text-brand-charcoal"
      >
        Top
      </button>
    </nav>
  );
};

export default SetupJumpBar;
